export enum BulkOperationTypeEnum {
  BULK_DEVICE_WORKFLOW = 'workflow',
  BULK_DEVICE_OWNERSHIP = 'ownership'
}